import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import AllNotificationLayout from './../../Component/Layouts/AllNotificationsLayout';

const mdTheme = createTheme();

function Notifications() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="All Notifications"/>
        <AllNotificationLayout />
      </Box>
    </ThemeProvider>
  );
}

export default function AllNotification() {
  return <Notifications />;
}
